import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  children: React.ReactNode;
}
export function Modal({
  isOpen,
  onClose,
  title,
  children
}: ModalProps) {
  useEffect(() => {
    const handleEsc = (e: KeyboardEvent) => {
      if (e.key === 'Escape') onClose();
    };
    if (isOpen) {
      document.addEventListener('keydown', handleEsc);
      document.body.style.overflow = 'hidden';
    }
    return () => {
      document.removeEventListener('keydown', handleEsc);
      document.body.style.overflow = '';
    };
  }, [isOpen, onClose]);
  return <AnimatePresence data-id="element-217">
      {isOpen && <motion.div className="fixed inset-0 z-50 flex items-center justify-center p-4 md:p-8" initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} transition={{
      duration: 0.2
    }} data-id="element-218">
          <div className="absolute inset-0 bg-teal/60 backdrop-blur-sm" onClick={onClose} aria-hidden="true" data-id="element-219" />
          <motion.div role="dialog" aria-modal="true" aria-labelledby="modal-title" className="relative bg-cream rounded-2xl shadow-2xl w-full max-w-2xl max-h-[85vh] flex flex-col border border-teal/10" initial={{
        opacity: 0,
        y: 20,
        scale: 0.98
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 20,
        scale: 0.98
      }} transition={{
        duration: 0.25,
        ease: [0.21, 0.47, 0.32, 0.98]
      }} data-id="element-220">
            <div className="flex items-center justify-between px-6 md:px-8 py-5 border-b border-teal/10" data-id="element-221">
              <h2 id="modal-title" className="font-serif text-xl md:text-2xl text-teal pr-4" data-id="element-222">
                {title}
              </h2>
              <button onClick={onClose} aria-label="Cerrar" className="flex-shrink-0 w-9 h-9 rounded-full flex items-center justify-center text-teal/60 hover:bg-teal/5 hover:text-teal transition-colors" data-id="element-223">
                <X size={20} strokeWidth={1.5} data-id="element-224" />
              </button>
            </div>
            <div className="overflow-y-auto px-6 md:px-8 py-6 text-teal/80 font-light leading-relaxed text-[15px] space-y-4" data-id="element-225">
              {children}
            </div>
            <div className="px-6 md:px-8 py-4 border-t border-teal/10 flex justify-end" data-id="element-226">
              <button onClick={onClose} className="px-5 py-2 text-sm font-medium uppercase tracking-wide text-cream bg-teal hover:bg-teal/90 rounded-sm transition-colors" data-id="element-227">
                Entendido
              </button>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}